import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

interface listDeletedFoldersParams {
  altId: string;
  altType: string;
}

interface restoreFolderParams {
  altId: string;
  altType: string;
  folderId: string;
}

const MediaServices = {
  listDeletedFolders: (params: listDeletedFoldersParams) =>
    requests(SERVICE_NAME.MEDIAS_API).get("deleted-folders", {
      params,
    }),

  restoreFolder: (params: restoreFolderParams) =>
    requests(SERVICE_NAME.MEDIAS_API).post("restore-folder", params),
};

export default MediaServices;
